import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-bbcf24dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "part-com" }
const _hoisted_2 = { class: "part-name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-ename" }, [
  /*#__PURE__*/_createTextVNode("Fujian & Jiangxi "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Investment Promotion")
], -1))
const _hoisted_4 = { class: "nav-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "new-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "avatar-wrap" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "news-des" }
const _hoisted_12 = { class: "des" }

import { ref, reactive, watch } from "vue";
import { getArticleQuery } from "../../request/api";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'imgNewTypeCom',
  props: {
  ColumnData: {
    type: Array, //类型字符串
    default: () => []
  },
  newsID: {
    type: Number, //每个组件对应特定的id
    default: () => ""
  }
},
  setup(__props) {

const props = __props;

// import { ref, reactive } from "vue";
// let currentNav: number = ref(0);
// let changeNav = (index: number) => {
//   currentNav.value = index;
// };
const router = useRouter();
//接收父组件传过来的值,需要注意defineProps只能在setup语法糖里面使用，不需要import引入

let toList = () => {
  router.push({
    path: "/pages/list/list",
    query: {
      level1Id: currentMenu.value.id,
      level2Id: currentMenu.value.children[currentNav.value].id,
      current: 0
    }
  });
};
// 声名获取列表的函数
let articleList = ref([]);
let getArticleList = () => {
  getArticleQuery({
    pageNum: 1,
    pageSize: 3,
    is_show: 1,
    column_id:
      currentMenu.value?.children[currentNav.value]?.id || currentMenu.value.id,
    title: ""
  }).then(res => {
    articleList.value = res.data.data;
    console.log(articleList.value, "articleList.value");
  });
};

// 菜单改变
console.log(props.newsID, "newsID");
console.log(props.ColumnData, "ColumnData1111");
let currentNav: number = ref(0);
let changeNav = (index: number) => {
  currentNav.value = index;
  getArticleList();
};

// 获取当前菜单以及子菜单
let currentMenu = ref({});
props.ColumnData.forEach(val => {
  if (val.id == props.newsID) {
    currentMenu.value = val;
    console.log(currentMenu.value, "currentMenu");
    getArticleList();
  }
});

// 前往文章详情

let articleDetail = item => {
  console.log(item, "id");
  if (item.link_url) {
    let url =
      item.link_url.substr(0, 4) == "http"
        ? item.link_url
        : "http://" + item.link_url;
    window.open(url);
  } else {
    router.push({
      path: "/pages/detail/detail",
      query: {
        id: item.id,
        level1Id: currentMenu.value.id,
        level2Id: currentMenu.value.children[currentNav.value].id
      }
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header-wrap",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.articlList(_unref(currentMenu).id)))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(currentMenu).name), 1),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentMenu).children, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab-item", _unref(currentNav)==index?'active-item':'']),
          onClick: ($event: any) => (_unref(changeNav)(index)),
          key: index
        }, _toDisplayString(item.name), 11, _hoisted_5))
      }), 128)),
      _createElementVNode("div", {
        class: "more-wrap",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(toList)()))
      }, [
        _createTextVNode("more "),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleList), (Aitem, Aindex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "news-item",
          key: Aindex,
          onClick: ($event: any) => (_unref(articleDetail)(Aitem))
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              class: "avatar",
              src: Aitem.image_url?Aitem.image_url:require('@/assets/empty.png'),
              alt: ""
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(Aitem.title), 1)
          ])
        ], 8, _hoisted_8))
      }), 128))
    ])
  ]))
}
}

})